const servicios = [
  { nombre: "Corte", precio: 15000, duracion: 1 },
  { nombre: "Lavado + Corte", precio: 20000, duracion: 1 },
  { nombre: "Corte + Nutrición + Brushing", precio: 30000, duracion: 2 },
  { nombre: "Nutrición", precio: 20000, duracion: 1 },

  {
    nombre: "Keratina",
    duracion: 2,
    opciones: [
      { tipo: "Corto", precio: 35000, duracion: 3 },
      { tipo: "Medio", precio: 40000, duracion: 3 },
      { tipo: "Largo", precio: 45000, duracion: 3 },
      { tipo: "Extra largo", precio: 50000, duracion: 3 }
    ]
  },




  {
    nombre: "Color Raíz",
    precio: 35000,
    duracion: 1
  },

  {
    nombre: "Color Completo",
    duracion: 2,
    opciones: [
      { tipo: "Corto", precio: 35000, duracion: 2 },
      { tipo: "Medio", precio: 40000, duracion: 2 },
      { tipo: "Largo", precio: 50000, duracion: 2 }
    ]
  },

  {
    nombre: "Mechas / Balayage",
    duracion: 3,
    opciones: [
      { tipo: "Corto", precio: 45000, duracion: 3 },
      { tipo: "Medio", precio: 50000, duracion: 3 },
      { tipo: "Largo", precio: 65000, duracion: 3 },
      { tipo: "Extra largo", precio: 85000, duracion: 3 }
    ]
  },

  {
    nombre: "Ondulación",
    duracion: 2,
    opciones: [
      { tipo: "Corto", precio: 45000, duracion: 2 },
      { tipo: "Medio", precio: 55000, duracion: 2 },
      { tipo: "Largo", precio: 65000, duracion: 2 }
    ]
  },

  { nombre: "Brushing", precio: 20000, duracion: 1 },
  { nombre: "Peinado (ondas o plancha)", precio: 25000, duracion: 1 },
  { nombre: "Recogido o Trenzas", precio: 35000, duracion: 1 },
  { nombre: "Novias / 15 años / Egreso", precio: 50000, duracion: 3 },


];

export default servicios;
